import { Component } from '@angular/core';
import { DetailInfoTypeComponent } from '../detail-info-type.component';

@Component({
    selector: 'detail-info-textbox',
    templateUrl: './detail-info-textbox.component.html',
    standalone: false
})
export class DetailInfoTextboxComponent extends DetailInfoTypeComponent {
  ngOnInit() {
    super.ngOnInit();
  }
}